import React, { useState, useEffect } from "react";
import styles from "./ChristmasSaleHeroV2.module.scss";
import { useNavigate } from 'react-router-dom';
import BaseC from "images/heros/ChristmasSaleV2/Christmas/Winter-scene-base-min.jpg";
import welcomeC from "images/heros/ChristmasSaleV2/Christmas/Winter-scene-welcome-min.jpg";
import tvpartyC from "images/heros/ChristmasSaleV2/Christmas/Winter-scene-tvparty-min.jpg";
import christmas from "images/heros/ChristmasSaleV2/Christmas/Winter-scene-christmas-min.jpg";
import newyear from "images/heros/ChristmasSaleV2/NewYear/Winter-scene-newyear-min.jpg";
import BaseNY from "images/heros/ChristmasSaleV2/NewYear/Winter-scene-base-min.jpg";
import welcomeNY from "images/heros/ChristmasSaleV2/NewYear/Winter-scene-welcome-min.jpg";
import tvpartyNY from "images/heros/ChristmasSaleV2/NewYear/Winter-scene-tvparty-min.jpg";
import OutlineText from "../../Utlility/OutlineText/OutlineText";

const ChristmasSaleHeroV2 = () => {
    const navigate = useNavigate();
    const now = new Date();
    const isChristmas = now.getMonth() === 11 && (now.getDate() < 26 || (now.getDate() === 26 && now.getHours() < 8));

    const christmasImages = [welcomeC, tvpartyC, christmas];
    const newYearImages = [welcomeNY, tvpartyNY, newyear];
    const images = isChristmas ? christmasImages : newYearImages;
    const baseImage = isChristmas ? BaseC : BaseNY;

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFlashing, setIsFlashing] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            setIsFlashing(true);
        }, 4000);
        return () => clearInterval(timer);
    }, []);

    const handleAnimationEnd = () => {
        setIsFlashing(false);
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    return (
        <div className={styles.heroContainer}>
            <div className={styles.imageStack}>
                <img
                    src={baseImage}
                    alt="Winter scene base"
                    className={styles.heroImage}
                />
                {images.map((image, index) => (
                    <img
                        key={index}
                        src={image}
                        alt={`Slide ${index + 1}`}
                        className={`${styles.heroImage} ${styles.overlayImage} ${index === currentIndex ? styles.visible : ''} ${index === currentIndex && isFlashing ? styles.flashing : ''}`}
                        onAnimationEnd={index === currentIndex ? handleAnimationEnd : undefined}
                    />
                ))}
            </div>
        </div>
    );
};

export default ChristmasSaleHeroV2;